import { ICreateTemplateTabModel } from "@/Appointments/Models/UI/Scheduling/ICreateTemplateTabModel";
import { IOpenScheduleTabModel } from "@/Appointments/Models/UI/Scheduling/IOpenScheduleTabModel";
import { ISchedulingTabModel } from "@/Appointments/Models/UI/Scheduling/ISchedulingTabModel";
import { ITemplateTabModel } from "@/Appointments/Models/UI/Scheduling/ITemplateTabModel";
import { EmptyProps } from "@/Common/Components/BaseReactComponent";
import { SchedulingTabViews } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { CreateTemplateTabView } from "./CreateTemplateTab";
import { MainTemplateTab } from "./MainTemplateTab";
import { OpenScheduleTabView } from "./OpenScheduleTab";

class SchedulingTabState {
    public TabModel: ISchedulingTabModel;
    public OpenScheduleModel: IOpenScheduleTabModel;
    public TemplateTabModel: ITemplateTabModel;
    public CreateTemplateTabModel: ICreateTemplateTabModel;
}

class SchedulingTab extends React.Component<EmptyProps, SchedulingTabState> {
    private schedulingChangeListenerMethodId: string;

    constructor(props: EmptyProps) {
        super(props);

        const initialState = new SchedulingTabState();
        initialState.TabModel = schedulingStore.SchedulingTabModel;
        initialState.OpenScheduleModel = schedulingStore.OpenScheduleTabModel;
        initialState.TemplateTabModel = schedulingStore.TemplateTabModel;
        initialState.CreateTemplateTabModel = schedulingStore.CreateTemplateTabModel;

        this.state = initialState;
    }

    public render(): JSX.Element {
        return (
            <div className="sub-container">
                <div className="patient-subtabs myle-page-tab-header" style={{ textAlign: "left" }} data-cy="schedulingTab">
                    <ul>
                        {this.buildProfileTab(SchedulingTabViews.MainTemplate, "CreateTemplateLabel")}
                        {this.buildProfileTab(SchedulingTabViews.OpenSchedule, "ScheduleAssignmentLabel")}
                    </ul>
                </div>

                <div>
                    {this.ShowTabComponents(this.state.TabModel.get("CurrentView"))}
                </div>
            </div>

        );
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
        this.schedulingChangeListenerMethodId = schedulingStore.AddChangeListener(this.changeListener, this, "scheduling-tab-listener");
    }

    public shouldComponentUpdate(nextProps: any, nextState: SchedulingTabState): boolean {
        return (
            this.state.TabModel !== nextState.TabModel
            || this.state.OpenScheduleModel !== nextState.OpenScheduleModel
            || this.state.TemplateTabModel !== nextState.TemplateTabModel
            || this.state.CreateTemplateTabModel !== nextState.CreateTemplateTabModel
        );
    }

    public componentWillUnmount(): void {
        schedulingStore.RemoveChangeListener(this.schedulingChangeListenerMethodId);
    }

    public changeListener(): void {
        var s = new SchedulingTabState();
        s.TabModel = schedulingStore.SchedulingTabModel;
        s.OpenScheduleModel = schedulingStore.OpenScheduleTabModel;
        s.TemplateTabModel = schedulingStore.TemplateTabModel;
        s.CreateTemplateTabModel = schedulingStore.CreateTemplateTabModel;

        this.setState(s);
    }

    private onTabClick(tab: SchedulingTabViews): void {
        var operation = new LocalEvent(LocalOperations.SchedulingTab.SubTabSwitch);
        operation.AddItem("value", tab);
        LocalEventDispatcher.dispatch(operation);
    }

    private buildProfileTab(tab: SchedulingTabViews, labelKey: string): JSX.Element {
        var css = this.state.TabModel.get("CurrentView") === tab ? "active" : null;
        if (this.state.TabModel.get("CurrentView") === SchedulingTabViews.CreateTemplate && tab === SchedulingTabViews.MainTemplate)
            var css = "active";

        return <li className={css}><a onClick={this.onTabClick.bind(this, tab)}>{cacheStore.GetString(labelKey)}</a></li>;
    }

    private ShowTabComponents(current: SchedulingTabViews): JSX.Element {
        switch (current) {
            case SchedulingTabViews.MainTemplate:
                return <MainTemplateTab Model={this.state.TemplateTabModel} />;

            case SchedulingTabViews.OpenSchedule:
                return <OpenScheduleTabView Model={this.state.OpenScheduleModel} />;

            case SchedulingTabViews.CreateTemplate:
                return <CreateTemplateTabView Model={this.state.CreateTemplateTabModel} />;
        }
    }
}

export { SchedulingTab };
